export const CATALOG_REFRESH_MS = 60_000

export function isCatalogPage(pathname: string) {
  return /^\/tw\/?$/.test(pathname) || /^\/tw\/store\/?$/.test(pathname) ||
    /^\/tw\/(products|selections)\/[^/]+\/?$/.test(pathname)
}

export function canRefreshCatalog(state: {
  pathname: string; now: number; lastRefresh: number; lastInteraction: number
  visible: boolean; online: boolean; busy: boolean
}) {
  return isCatalogPage(state.pathname) && state.visible && state.online && !state.busy &&
    state.now - state.lastRefresh >= CATALOG_REFRESH_MS &&
    state.now - state.lastInteraction >= 5_000
}
